import React from 'react';
import { Tooltip } from 'react-tippy';
import { ApIcon, colors } from '@alixpartners/ui-components';

import { copyTextToClipboard } from 'utils/clipboard';
import Modal from 'components/Modal';

import {
	Header,
	Body,
	CloseIcon,
	CorrelationId,
	Label,
	TooltipPosition,
	DemoModeInfo,
} from './styles';

let handlers = [];

export class ApiErrorNotification extends React.Component {
	state = {
		open: false,
		showCopiedTooltip: false,
		errorId: null,
		isDemoModeError: false,
	};

	closeDialog = () => {
		this.setState({ open: false, errorId: null });
	};

	openDialog = (errorId, isDemoModeError = false) => {
		this.setState({ open: true, isDemoModeError, errorId });
	};

	componentDidMount() {
		handlers.push(this.openDialog);
	}

	componentWillUnmount() {
		handlers = handlers.filter(handler => handler !== this.openDialog);
	}

	componentDidUpdate(_prevProps, prevState) {
		if (!prevState.showCopiedTooltip && this.state.showCopiedTooltip) {
			setTimeout(() => this.setState({ showCopiedTooltip: false }), 2000);
		}
	}

	render() {
		const { open, errorId, isDemoModeError, showCopiedTooltip } = this.state;

		if (!open) {
			return null;
		}

		let title = 'Sorry, something went wrong';

		if (isDemoModeError) {
			title = 'Demo mode';
		}

		return (
			<Modal width="553px" zIndex="10000000" onClose={this.closeDialog}>
				<Header>
					{title}
					<CloseIcon onClick={this.closeDialog}>
						<ApIcon
							iconName="baseline_close"
							iconSize="26px"
							iconColor={colors.grey4}
						/>
					</CloseIcon>
				</Header>
				{isDemoModeError ? (
					<Body>
						<div>This feature is not available in demo mode</div>
						<DemoModeInfo>
							API you are trying to access: <pre>{errorId}</pre>
						</DemoModeInfo>
					</Body>
				) : (
					<Body>
						<div>Please contact your representative for help.</div>
						<Label>Correlation ID:</Label>
						<Tooltip
							title="Copied"
							position="top"
							animation="none"
							trigger="click"
							arrow
							open={showCopiedTooltip}
						>
							<TooltipPosition />
						</Tooltip>
						<CorrelationId
							onClick={() => {
								copyTextToClipboard(errorId);
								this.setState({ showCopiedTooltip: true });
							}}
						>
							{errorId}
						</CorrelationId>
					</Body>
				)}
			</Modal>
		);
	}
}

export const handleApiError = (...args) => {
	handlers.forEach(handler => handler(...args));
};
